import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { withRouter } from 'react-router-dom';
import NavigationTabs from '../nav/NavigationTabs';
import { AlertJsMessage } from './../../helpers.js';
import DynamicStepper from './DynamicStepper';

class Form extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dataLoaded: false,
			editAutomation: null,
			isValidating: false,
			submitAction: 'create',
			isAudioDelete: false,
			formData: {
				name: ''
			},
		};
	}
	componentDidMount() {
		if (this.props.editId) {
			this.props.fetch(this.props.user._id || localStorage.id, this.props.editId).then((res) => {
				const { editId, instructions } = this.props;
				const data = res.data;
				this.setState({
					...this.state,
					formData: {
						name: data.name
					},
					automationSteps: data.automationSteps,
					dataLoaded: true,
					submitAction: 'edit'
				})
			});
		}
	}

	
	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};
	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};
	validateForm() {
		let formData = { ...this.state.formData };
		const lib_URL = '/library/automationMessages';
		const { addAutomation, edit, editId, history, user, onClose } = this.props;
		const required = ['name'];
		for (var i = 0; i < required.length; i++) {
			if (!formData[required[i]]) {
				AlertJsMessage('Please enter all fields.');
				return;
			}
		}
		let steps = this.stepForm.state.steps;
    	const savedSteps =  steps.filter((s) => s.isSaved );
		if (savedSteps.length === 0) {
			AlertJsMessage('Please save atleast one trigger.');
		    return;
		}
		steps = steps.filter((s) => {
			return s.isStartTrigger || s.isSaved
		})
		formData = {
			...formData,
			automationSteps: steps
		}
		if (this.state.submitAction === 'create') {
			addAutomation(formData, user.type).then(() => {
				history.push(lib_URL);
			});
		} else {
			edit(editId, formData, user.type).then(() => {
				onClose && onClose();
				setTimeout(() => {
					window.location.reload();
				});
			});
		}
	}

	renderMenuOptions = option => (
		<MenuItem key={option._id} value={option._id}>
			{option.name}
		</MenuItem>
	);

	render() {
		const { formData, dataLoaded } = this.state;
		const { cats } = this.props;
		return (
			<div>
				{this.props.hideNavigationTabs ? null : (
					<NavigationTabs
						title="Build"
						subtitle="Automated Messages"
						set="build"
						activeRoute="/build/automationMessages"
					/>
				)}
					<React.Fragment>
						{ ! this.props.isReadOnly ?
						<TextField
						    style={{'maxWidth': 400}}
							label="Name"
							value={formData.name}
							onChange={this.handleChange('name')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 200 }}
						/> : <span style={{fontSize: 14, fontWeight: 'bold'}}>{formData.name}</span> }
						 <DynamicStepper  ref={(ref) => { 
							 this.stepForm = ref;
						  }} isReadOnly={this.props.isReadOnly} editId = {this.props.editId} automationSteps = {this.state.automationSteps} />
						{ !this.props.isReadOnly && 
							<Button
								disabled={this.state.isValidating}
								onClick={() => this.validateForm()}
								variant="contained"
								color="primary"
								style={{'marginTop': '15px'}}
							>
								{this.state.editAutomation ? 'Save' : 'Save'}
							</Button>
						}
					</React.Fragment>
			</div>
		);
	}
}
export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/automations/Form.js